module.exports = __webpack_public_path__ + "static/media/loading-min.b412183c.gif";